module.exports = {
      id: "line-arrow-next-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#line-arrow-next",
      toString: function () {
        return this.url;
      }
    }